export default __webpack_public_path__ + "static/media/svg2.ab5dc8c4.svg";